module.exports = __webpack_public_path__ + "static/img/20001 (3).a8c96ef.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20001 (3).webp
// module id = au4+
// module chunks = 14